export function areEqualValues(first, second) {
  if (typeof second === 'object' && second !== null) {
    return first === second;
  }
  return String(first) === String(second);
}

export function createChainedFunction() {
  const args = [].slice.call(arguments, 0);
  if (args.length === 1) {
    return args[0];
  }
  return function chainedFunction() {
    for (let i = 0; i < args.length; i += 1) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

export function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn?.(event);
      return event?.defaultPrevented;
    });
  };
}
